import {
  Component,
  Input,
  OnInit,
  ChangeDetectionStrategy
} from "@angular/core";

@Component({
  selector: "hbr-chart-detail-value",
  template: `<div class="row flex-items-xs-between values-header">
    <div *ngIf="valueMode" class="title-container">
        <label>{{'HELM_CHART.SHOW_KV' | translate }}</label>
    </div>
    <div *ngIf="!valueMode" class="title-container">
        <label>{{'HELM_CHART.SHOW_YAML' | translate }}</label>
    </div>
    <div class="switch-container">
        <span class="card-btn" (click)="showYamlFile(false)" (mouseenter)="mouseEnter('value') " (mouseleave)="mouseLeave('value')">
            <clr-icon size="24" shape="view-list" title='list values' [ngClass]="{'is-highlight': isValueMode || isHovering('value') }"></clr-icon>
        </span>
        <span class="list-btn" (click)="showYamlFile(true)" (mouseenter)="mouseEnter('yaml') " (mouseleave)="mouseLeave('yaml')">
            <clr-icon size="24" shape="file" title="yaml file" [ngClass]="{'is-highlight': !isValueMode || isHovering('yaml') }"></clr-icon>
        </span>
    </div>
</div>

<div class="row value-container">
    <div class="col-xs-8" *ngIf="valueMode">
        <table class="table">
            <tbody>
                <tr *ngFor="let key of objKeys(values)">
                    <td class="left">{{key}}</td>
                    <td class="left">{{values[key]}}</td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="col-xs-8" *ngIf="!valueMode">
        <div class="yaml-container" [innerHTML]="yaml | language : 'yaml' | markdown"></div>
    </div>
</div>`,
  styles: [`.value-container ::ng-deep pre{min-height:-webkit-fit-content;min-height:-moz-fit-content;min-height:fit-content}.values-header{margin-top:12px}.values-header .title-container{margin-left:15px}.values-header .switch-container{margin-right:15px}pre{max-height:-webkit-max-content;max-height:-moz-max-content;max-height:max-content;padding-left:21px}`],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChartDetailValueComponent implements OnInit {
  @Input() values;
  @Input() yaml;

  // Default set to yaml file
  valueMode = false;
  valueHover = false;
  yamlHover = true;

  objKeys = Object.keys;

  constructor() {}

  ngOnInit(): void {
  }

  public get isValueMode() {
    return this.valueMode;
  }

  isHovering(view: string) {
    if (view === 'value') {
      return this.valueHover ? true : false;
    } else {
      return this.yamlHover ? true : false;
    }
  }

  showYamlFile(showYaml: boolean) {
    this.valueMode = !showYaml;
  }

  mouseEnter(mode: string) {
    if (mode === "value") {
      this.valueHover = true;
    } else {
      this.yamlHover = true;
    }
  }

  mouseLeave(mode: string) {
    if (mode === "value") {
      this.valueHover = false;
    } else {
      this.yamlHover = false;
    }
  }
}
